import React, { useRef } from 'react';
import { Paperclip } from 'lucide-react';
import styles from '../../styles/FileUpload.module.css';
import { MAX_FILE_SIZE, MAX_FILE_SIZE_MB, MAX_FILES_PER_MESSAGE } from '../../config';

const ALLOWED_FILE_TYPES = {
  documents:     '.pdf,.docx,.txt',
  data:          '.csv,.tsv,.json,.xml',
  spreadsheets:  '.xlsx,.xls',
  presentations: '.pptx',
  code:          '.py,.js,.ts,.tsx,.jsx,.java,.cpp,.c,.h,.go,.rs,.rb,.php,.sh,.cs,.html,.css,.md',
  other:         '.log,.yaml,.yml,.ini',
  images:        '.jpg,.jpeg,.png,.gif,.webp,.tiff,.bmp',
};

const ALL_TYPES = Object.values(ALLOWED_FILE_TYPES).join(',');

export default function FileUploadButton({ onFilesSelected, onValidationError, disabled, currentFiles = [] }) {
  const fileInputRef = useRef(null);

  const validateFiles = (files) => {
    const errors = [];
    const validFiles = [];
    
    // Check max files limit
    if (currentFiles.length + files.length > MAX_FILES_PER_MESSAGE) {
      errors.push(`Maximum ${MAX_FILES_PER_MESSAGE} files allowed per message`);
      return { validFiles: [], errors };
    }

    for (const file of files) {
      // Check file size
      if (file.size > MAX_FILE_SIZE) {
        errors.push(`${file.name} exceeds ${MAX_FILE_SIZE_MB}MB limit`);
        continue;
      }

      // Check file type
      const extension = '.' + file.name.split('.').pop().toLowerCase();
      const isAllowed = ALL_TYPES.split(',').includes(extension);
      
      if (!isAllowed) {
        errors.push(`${file.name} has unsupported file type`);
        continue;
      }

      validFiles.push(file);
    }

    return { validFiles, errors };
  };

  const handleFileSelect = (e) => {
    console.log('🔵 STEP 1: Files selected', e.target.files);
    
    const files = Array.from(e.target.files);
    console.log('🔵 STEP 1.1: Files array', files);
    
    const { validFiles, errors } = validateFiles(files);
    console.log('🔵 STEP 1.2: Validation result', { validFiles, errors });

    if (errors.length > 0) {
        console.error('🔴 STEP 1.3: Validation errors:', errors);
        onValidationError?.(errors.join('\n'));
    }

    if (validFiles.length > 0) {
        console.log('🔵 STEP 1.4: Calling onFilesSelected with:', validFiles);
        onFilesSelected(validFiles);
    }

    e.target.value = '';
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={ALL_TYPES}
        onChange={handleFileSelect}
        className={styles.hiddenInput}
        disabled={disabled}
      />
      <button
        type="button"
        onClick={handleClick}
        disabled={disabled}
        className={styles.uploadButton}
        title="Attach files"
      >
        <Paperclip size={20} />
      </button>
    </>
  );
}